/**
 * The only file allowed to read `import.meta.env`. Jest swaps it for src/test/env.mock.ts.
 * Empty VITE_* URLs mean "same origin": Vite proxies /api, /_ and the service prefixes in dev,
 * Caddy in prod.
 */
export const env = {
  appName: import.meta.env.VITE_APP_NAME || "PrestoBooks",
  pocketbaseUrl: import.meta.env.VITE_POCKETBASE_URL || "/",
  aiUrl: import.meta.env.VITE_AI_URL || "/ai",
  billingUrl: import.meta.env.VITE_BILLING_URL || "/billing",
  inboxUrl: "/inbox",
  /** Domain of the er-/ar-/ka- inbox addresses (must match INBOX_DOMAIN of services/inbox). */
  inboxDomain: import.meta.env.VITE_INBOX_DOMAIN || "in.localhost",
  /** Plausible site (app.prestobooks.at). Empty disables analytics (dev, CI, e2e). */
  plausibleDomain: import.meta.env.VITE_PLAUSIBLE_DOMAIN || "",
  /** Sentry project DSN (public by design). Empty disables error reporting. */
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || "",
  /** dev or production, from the deploy's SENTRY_ENVIRONMENT. */
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
} as const;
